import {
  CORE_DELETE_CUSTOMER_REQUEST,
  CORE_DELETE_CUSTOMER_SUCCESS,

  CORE_DELETE_CONTACT_REQUEST,
  CORE_DELETE_CONTACT_SUCCESS,

  CORE_DELETE_PRODUCT_REQUEST,
  CORE_DELETE_PRODUCT_SUCCESS,

  CORE_DELETE_VERSION_REQUEST,
  CORE_DELETE_VERSION_SUCCESS,

  CORE_DELETE_PROFILE_REQUEST,
  CORE_DELETE_PROFILE_SUCCESS,

  CORE_DELETE_DEVICE_REQUEST,
  CORE_DELETE_DEVICE_SUCCESS,

  CORE_DELETE_IOTACCESSORY_REQUEST,
  CORE_DELETE_IOTACCESSORY_SUCCESS,

  CORE_DELETE_IOTROOM_REQUEST,
  CORE_DELETE_IOTROOM_SUCCESS,

  CORE_DELETE_USER_REQUEST,
  CORE_DELETE_USER_SUCCESS,

  CORE_DELETE_LICENSE_REQUEST,
  CORE_DELETE_LICENSE_SUCCESS,
} from '../types'

const initialState = {
  status: false,
  date: '',
  id: ''
}
export default {
  deleteState: (state = initialState, action) => {
    switch (action.type) {
      case CORE_DELETE_CUSTOMER_REQUEST:
      case CORE_DELETE_CONTACT_REQUEST:
      case CORE_DELETE_PRODUCT_REQUEST:
      case CORE_DELETE_VERSION_REQUEST:
      case CORE_DELETE_PROFILE_REQUEST:
      case CORE_DELETE_DEVICE_REQUEST:
      case CORE_DELETE_IOTACCESSORY_REQUEST:
      case CORE_DELETE_IOTROOM_REQUEST:
      case CORE_DELETE_USER_REQUEST:
      case CORE_DELETE_LICENSE_REQUEST:
        return initialState
      case CORE_DELETE_CUSTOMER_SUCCESS:
      case CORE_DELETE_CONTACT_SUCCESS:
      case CORE_DELETE_PRODUCT_SUCCESS:
      case CORE_DELETE_VERSION_SUCCESS:
      case CORE_DELETE_PROFILE_SUCCESS:
      case CORE_DELETE_DEVICE_SUCCESS:
      case CORE_DELETE_IOTACCESSORY_SUCCESS:
      case CORE_DELETE_IOTROOM_SUCCESS:
      case CORE_DELETE_USER_SUCCESS:
      case CORE_DELETE_LICENSE_SUCCESS:
        return action.payload
      default:
        return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reducerDeleteState.js